import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import ValueProp from './components/ValueProp';
import Benefits from './components/Benefits';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import RealEstate from './components/RealEstate';
import Ecommerce from './components/Ecommerce';
import ClickFunnels from './components/ClickFunnels';
import FreeTrial from './components/FreeTrial';
import RealEstateLeadMagnet from './components/RealEstateLeadMagnet';
import StructuredData from './components/StructuredData';
import AIQuiz from './components/AIQuiz';

const PageHelmet = () => {
  const location = useLocation();
  const baseUrl = 'https://salesintercept.com';
  const currentUrl = `${baseUrl}${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Router>
      <div className="App">
        <PageHelmet />
        <StructuredData />
        <Routes>
          <Route path="/free-download/real-estate-lead-ideas" element={<RealEstateLeadMagnet />} />
          <Route path="*" element={
            <>
              <Header isScrolled={isScrolled} />
              <Routes>
                <Route path="/" element={
                  <main>
                    <Hero />
                    <ValueProp />
                    <Benefits />
                    <Features />
                    <Pricing />
                    <Testimonials />
                    <CallToAction />
                  </main>
                } />
                <Route path="/real-estate" element={<RealEstate />} />
                <Route path="/ecommerce" element={<Ecommerce />} />
                <Route path="/clickfunnels" element={<ClickFunnels />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/lander/free-trial-invitation" element={<FreeTrial />} />
                <Route path="/ai-quiz" element={<AIQuiz />} />
                <Route path="/ai-quiz/question/:questionNumber" element={<AIQuiz />} />
                <Route path="/ai-quiz/results/:tier" element={<AIQuiz />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;